import { AcademicCalendarActions } from "./action";

const initialState = {
  AcademicCalendarData: [],
};

export const AcademicCalendarReducer = (state = initialState, action) => {
  switch (action.type) {
    case AcademicCalendarActions.SET_ACADEMIC_CALENDAR:
      return {
        ...state,
        AcademicCalendarData: action.payload,
      };
    default:
      return state;
  }
};
